export const elementAmount = {
    "single": 1,
    "double": 2,
    "triple": 3,
}